import React from "react";
import Card from "./Card";

const Blog = ( {data} ) => {
    return(
        <div className="flex flex-col p-5 gap-12">

            <div className="flex items-center md:gap-40 gap-32"> 

                <button className="flex main-custom-return-button items-center justify-center relative group border-solid rounded-full w-14 h-14" onClick={ () => window.location.replace(data.header.source_url) }>
                    <img className="absolute transition-opacity duration-500 ease-linear opacity-100 group-hover:opacity-0" src={data.header.arrow} alt="arrow"/>
                    <img className="absolute transition-opacity duration-500 ease-linear opacity-0 group-hover:opacity-100 rotate-180" src={data.header.arrow_hover} alt="arrow"/>
                </button>

                <span className="text-[56px] font-medium" style={{color: data.header.color}}>{data.header.title}</span>
            </div>

            <Card data= {data}/>
        </div>
    );
};

export default Blog;